import UltMeta, { Meta } from "@/meta/UltMeta/index";

class ServiceCostType extends UltMeta {
    UNIT_PRICE = new Meta(1, "单价收费");
    FIXED_PRICE = new Meta(2, "一口价收费");
}

export const SERVICE_COST_TYPE = new ServiceCostType();

class BillState extends UltMeta {
    NOT_WRITTEN_OFF = new Meta(1, "未核销");
    WRITTEN_OFF = new Meta(2, "已核销");
}
export const BILL_STATE = new BillState();
class ServiceCostSource extends UltMeta {
    PROJECT = new Meta(1, "项目服务费");
}

export const SERVICE_COST_SOURCE = new ServiceCostSource();

class ServiceCostState extends UltMeta {
    UNSETTLED = new Meta(1, "未结算", "un-settle-state");
    SETTLED = new Meta(2, "已结算", "settle-state");
    AUTO_SETTLED = new Meta(3, "自动结算", "auto-state");
}

export const SERVICE_COST_STATE = new ServiceCostState();
class IntendServiceCostRoleIndex extends UltMeta {
    BUYER_INDEX = new Meta(0, "采购商服务费明细");
    SUPPLIER_INDEX = new Meta(1, "供应商服务费明细");
    SC_INDEX = new Meta(2, "联合购销商服务费明细");
}
export const INTEND_SERVICE_COST_ROLE_INDEX = new IntendServiceCostRoleIndex();
class ServiceCostRoleIndex extends UltMeta {
    SUPPLIER_INDEX = new Meta(0, "供应商服务费明细");
    SC_INDEX = new Meta(1, "联合购销商服务费明细");
    /**后端不接 */
    BUYER_INDEX = new Meta(2, "采购商服务费明细");
}
export const SERVICE_COST_ROLE_INDEX = new ServiceCostRoleIndex();
